import SessionAttendanceChips from './SessionAttendanceChips';

export default SessionAttendanceChips;
export { getSessionSelectionSummary } from './sessionSelectionSummary';
export type { SessionSelectionSummary } from './sessionSelectionSummary';
export type { Props, SessionChipOption } from './types';
